
import { Campaign, FacebookPost, Post } from "./interfaces"

export const USERS_COMMENTS_CONTAINER = 'CommentPosts'
export const USERS_REPORTS_CONTAINER = 'UserReports'
export const POSTS_DB_CONTAINER = 'DemoPostsDB'

export const FACEBOOK_APP_ID = '2432061427183374'

export const development = true
export const AMAZON_CAMPAIGN_ENDPOINTS2 = development? 'https://10.0.0.4:3000/api' : 'http://13.48.1.182:8000'


export const LOGS_DB_CONTAINER = 'UserLogs'

export const POSTS_DB = 'Website'

export const card_height = 1200;
export const post_to_show= 10;
export const BOOKMARK = 'bookmark'
export const SENT = 'sent';
export const DATABASE_BASEURL = `https://rhetoric-ai-database.azurewebsites.net/api/`;

export const createQueryForBookmarked= (mail: string) => `SELECT * FROM c WHERE IS_DEFINED(c.bookmarkBy) AND ARRAY_CONTAINS(c.bookmarkBy, '${mail}')`

export const FACEBOOK_POSTS: FacebookPost[] = [
    {
        "id": "256029224255177_122102283212226747",
        "message": "this is my second post",
        "url": "https://www.facebook.com/122102264618226747/posts/122102283212226747",
        "commentsCount": 5,
        "comments": [
            {
                "content": "YYYYYYYYYXXXXXXXXX test",
                "id": "122102283212226747_291877663756069",
                "author": {
                    "name": "Rt testing",
                    "id": "256029224255177"
                },
                "likes": 0,
                "commentCount": 1,
                "comments": [
                    {
                        "content": "@@@@@@@@@I understand your perspective, but it's important to consider the broader context of @@@@@@@ the Israeli-Hamas conflict. The recent events on October 7@@@",
                        "id": "122102283212226747_1610861909478918",
                        "author": {
                            "name": "Rt testing",
                            "id": "256029224255177"
                        },
                        "likes": 0
                    }
                ]
            },
            {
                "content": "Hello world!",
                "id": "122102283212226747_1128546861917892",
                "author": {
                    "name": "Rt testing",
                    "id": "256029224255177"
                },
                "likes": 0,
                "commentCount": 5,
                "comments": [
                    {
                        "content": "Israel's military action in response to Hamas's attacks is a legitimate act of self-defense. The IDF's operational objectives, including rescuing kidnapped civilians and dismantling Hamas, have been endorsed by the US Biden administration and other world leaders. It is crucial to recognize that Israel faces constant threats from terrorist organizations",
                        "id": "122102283212226747_418699560828395",
                        "author": {
                            "name": "Rt testing",
                            "id": "256029224255177"
                        },
                        "likes": 0
                    },
                    {
                        "content": "Israel's military action in response to Hamas's attacks is not only justified but also necessary for the security and well-being of its citizens. The IDF has consistently demonstrated its commitment to minimizing civilian casualties through measures like dropping warning leaflets and conducting \"roof knocking\" before strikes. It is crucial to recognize that",
                        "id": "122102283212226747_2805717772927651",
                        "author": {
                            "name": "Rt testing",
                            "id": "256029224255177"
                        },
                        "likes": 0
                    },
                    {
                        "content": "Israel's military action in response to Hamas's attacks is not only justified but also necessary for the security and well-being of its citizens. The IDF has consistently demonstrated its commitment to minimizing civilian casualties through measures like dropping warning leaflets and conducting \"roof knocking\" before strikes. It is crucial to recognize that",
                        "id": "122102283212226747_897327755462717",
                        "author": {
                            "name": "Rt testing",
                            "id": "256029224255177"
                        },
                        "likes": 0
                    },
                    {
                        "content": "Israel's military action in response to Hamas's attacks is a necessary measure to protect its citizens and dismantle a terrorist organization. The IDF has consistently demonstrated its commitment to minimizing civilian casualties through measures like dropping warning leaflets and conducting \"roof knocking.\" It is crucial to recognize that Hamas intentionally embeds military assets",
                        "id": "122102283212226747_911669087284865",
                        "author": {
                            "name": "Rt testing",
                            "id": "256029224255177"
                        },
                        "likes": 0
                    },
                    {
                        "content": "XXXXXXXX Israel's actions in response to the Hamas attack were necessary to protect its citizens and restore security. The IDF's operational objectives, endorsed by world leaders, aim to rescue kidnapped civilians and dismantle Hamas. It is crucial to consider the context of Hamas's tactics, such as using human shields and building military installations",
                        "id": "122102283212226747_259896663755390",
                        "author": {
                            "name": "Rt testing",
                            "id": "256029224255177"
                        },
                        "likes": 0
                    }
                ]
            },
            {
                "content": "Test 2",
                "id": "122102283212226747_1097148944940892",
                "author": {
                    "name": "Ronen Irani",
                    "id": "25048567564757739"
                },
                "likes": 0,
                "commentCount": 2,
                "comments": [
                    {
                        "content": "I understand your perspective, but it's important to consider the broader context of the Israeli-Hamas conflict. Hamas militants launched a large-scale attack on Israel, firing thousands of rockets into civilian areas and kidnapping innocent people. Israel's response aims to rescue kidnapped civilians and dismantle Hamas, which not only threatens Israeli",
                        "id": "122102283212226747_423095763459335",
                        "author": {
                            "name": "Rt testing",
                            "id": "256029224255177"
                        },
                        "likes": 0
                    },
                    {
                        "content": "I understand your perspective, but it's important to consider the broader context of the Israeli-Hamas conflict. Hamas militants launched a large-scale attack on Israel, firing thousands of rockets into civilian areas and kidnapping innocent people. Israel's response aims to rescue kidnapped civilians and dismantle Hamas, which not only threatens Israeli",
                        "id": "122102283212226747_1150687802590144",
                        "author": {
                            "name": "Rt testing",
                            "id": "256029224255177"
                        },
                        "likes": 0
                    }
                ]
            },
            {
                "content": "hi",
                "id": "122102283212226747_259122723817638",
                "author": {
                    "name": "Doron Fars",
                    "id": "7165916503457442"
                },
                "likes": 0,
                "commentCount": 1,
                "comments": [
                    {
                        "content": "Israel's right to defend itself and protect its citizens is unquestionable. The recent attacks by Hamas militants, which resulted in the deaths of innocent Israelis and the kidnapping of civilians, were heinous acts of terrorism. Israel has a moral obligation to dismantle Hamas and ensure the safety and security of its people.",
                        "id": "122102283212226747_2075993192771444",
                        "author": {
                            "name": "Rt testing",
                            "id": "256029224255177"
                        },
                        "likes": 0
                    }
                ]
            },
            {
                "content": "test1",
                "id": "122102283212226747_1457587651633554",
                "author": {
                    "name": "Doron Fars",
                    "id": "7165916503457442"
                },
                "likes": 0,
                "commentCount": 3,
                "comments": [
                    {
                        "content": "This post is unavailable. Try another!",
                        "id": "122102283212226747_726258652962558",
                        "author": {
                            "name": "Rt testing",
                            "id": "256029224255177"
                        },
                        "likes": 0
                    },
                    {
                        "content": "This post is unavailable. Try another!",
                        "id": "122102283212226747_344269861343604",
                        "author": {
                            "name": "Rt testing",
                            "id": "256029224255177"
                        },
                        "likes": 0
                    },
                    {
                        "content": "This post is unavailable. Try another!",
                        "id": "122102283212226747_273830909139916",
                        "author": {
                            "name": "Rt testing",
                            "id": "256029224255177"
                        },
                        "likes": 0
                    }
                ]
            }
        ]
    },
    {
        "id": "256029224255177_122098903892226747",
        "message": "This is my first post!",
        "url": "https://www.facebook.com/122102264618226747/posts/122098903892226747",
        "commentsCount": 4,
        "comments": [
            {
                "content": "test4",
                "id": "122098903892226747_1969834340097738",
                "author": {
                    "name": "Doron Fars",
                    "id": "7165916503457442"
                },
                "likes": 0,
                "commentCount": 2,
                "comments": [
                    {
                        "content": "I appreciate your perspective, and it's important to have a nuanced understanding of the situation. The Israeli Defense Forces (IDF) launched their ground invasion in Gaza with the primary objective of rescuing kidnapped civilians and dismantling Hamas. This operation was endorsed by the US Biden administration and other world leaders as",
                        "id": "122098903892226747_1097084128077656",
                        "author": {
                            "name": "Rt testing",
                            "id": "256029224255177"
                        },
                        "likes": 0
                    },
                    {
                        "content": "I completely agree with your statement. The situation in Israel is complex and multifaceted, but it is crucial to recognize the legitimate security concerns that Israel faces. The unprovoked attack by Hamas on October 7th, 2023, resulted in the deaths of innocent Israeli civilians and soldiers, as well as the kidnapping of numerous individuals from different nationalities.\n\nIsrael's response to this aggression was not only a matter of self-defense but also aimed at dismantling Hamas and rescuing the kidnapped civilians",
                        "id": "122098903892226747_1137644117671166",
                        "author": {
                            "name": "Rt testing",
                            "id": "256029224255177"
                        },
                        "likes": 0
                    }
                ]
            },
            {
                "content": "test2",
                "id": "122098903892226747_394288649881420",
                "author": {
                    "name": "Doron Fars",
                    "id": "7165916503457442"
                },
                "likes": 0,
                "commentCount": 0,
                "comments": []
            },
            {
                "content": "test3",
                "id": "122098903892226747_458108139877920",
                "author": {
                    "name": "Doron Fars",
                    "id": "7165916503457442"
                },
                "likes": 0,
                "commentCount": 0,
                "comments": []
            },
            {
                "content": "test1",
                "id": "122098903892226747_266495079728293",
                "author": {
                    "name": "Doron Fars",
                    "id": "7165916503457442"
                },
                "likes": 0,
                "commentCount": 0,
                "comments": []
            }
        ]
    },
    {
        "id": "256029224255177_122098902860226747",
        "url": "https://www.facebook.com/122102264618226747/posts/122098902860226747?substory_index=245024975350468",
        "message": "",
        "commentsCount": 3,
        "comments": [
            {
                "content": "Convince me",
                "id": "122098902860226747_7627186453979454",
                "author": {
                    "name": "Ronen Irani",
                    "id": "25048567564757739"
                },
                "likes": 0,
                "commentCount": 7,
                "comments": [
                    {
                        "content": "test response",
                        "id": "122098902860226747_917216536774347",
                        "author": {
                            "name": "Rt testing",
                            "id": "256029224255177"
                        },
                        "likes": 0
                    },
                    {
                        "content": "test",
                        "id": "122098902860226747_922732896063239",
                        "author": {
                            "name": "Rt testing",
                            "id": "256029224255177"
                        },
                        "likes": 0
                    },
                    {
                        "content": "message",
                        "id": "122098902860226747_446372764381643",
                        "author": {
                            "name": "Rt testing",
                            "id": "256029224255177"
                        },
                        "likes": 0
                    },
                    {
                        "content": "message",
                        "id": "122098902860226747_3766853823604420",
                        "author": {
                            "name": "Rt testing",
                            "id": "256029224255177"
                        },
                        "likes": 0
                    },
                    {
                        "content": "test",
                        "id": "122098902860226747_290609940518718",
                        "author": {
                            "name": "Rt testing",
                            "id": "256029224255177"
                        },
                        "likes": 0
                    },
                    {
                        "content": "second message",
                        "id": "122098902860226747_416719510897925",
                        "author": {
                            "name": "Rt testing",
                            "id": "256029224255177"
                        },
                        "likes": 0
                    },
                    {
                        "content": "second message",
                        "id": "122098902860226747_806479041508579",
                        "author": {
                            "name": "Rt testing",
                            "id": "256029224255177"
                        },
                        "likes": 0
                    }
                ]
            },
            {
                "content": "check",
                "id": "122098902860226747_1474092390151426",
                "author": {
                    "name": "Doron Fars",
                    "id": "7165916503457442"
                },
                "likes": 0,
                "commentCount": 2,
                "comments": [
                    {
                        "content": "I understand your perspective, and it is crucial to consider multiple viewpoints in any discussion. However, it is important to acknowledge that the Israeli Defense Forces (IDF) launched their ground invasion of Gaza with the primary objective of rescuing kidnapped civilians and dismantling Hamas. This operation was endorsed by the US",
                        "id": "122098902860226747_375009468732733",
                        "author": {
                            "name": "Rt testing",
                            "id": "256029224255177"
                        },
                        "likes": 0
                    },
                    {
                        "content": "I understand your perspective, and it is crucial to consider multiple viewpoints in any discussion. However, it is important to acknowledge that the Israeli Defense Forces (IDF) launched their ground invasion of Gaza with the primary objective of rescuing kidnapped civilians and dismantling Hamas. This operation was endorsed by the US",
                        "id": "122098902860226747_428638969628257",
                        "author": {
                            "name": "Rt testing",
                            "id": "256029224255177"
                        },
                        "likes": 0
                    }
                ]
            },
            {
                "content": "I disagree",
                "id": "122098902860226747_412828997792051",
                "author": {
                    "name": "Ronen Irani",
                    "id": "25048567564757739"
                },
                "likes": 0,
                "commentCount": 1,
                "comments": [
                    {
                        "content": "this response was genereated as a test, 11:52:12:2024:02:27",
                        "id": "122098902860226747_954057968888953",
                        "author": {
                            "name": "Rt testing",
                            "id": "256029224255177"
                        },
                        "likes": 0
                    }
                ]
            }
        ]
    }
]

export const ISAREL = "israel"
export const createQueryForAnswered= (mail: string) => `SELECT * FROM c WHERE IS_DEFINED(c.answeredBy) AND ARRAY_CONTAINS(c.answeredBy, '${mail}')`
export const EMPTY_CAMPAIGNs : Campaign[] = [{
    nameOfTheCampaign: "Campaign1",
    reasonForCampaignExistence: "",
    campaignGuidelines: "",
    targetAudience: "",
    campaignCreatorId: "",
    campaignID: ""
},{
    nameOfTheCampaign: "Campaign2",
    reasonForCampaignExistence: "",
    campaignGuidelines: "",
    targetAudience: "",
    campaignCreatorId: "",
    campaignID: ""
}]
export const LOGSTYPE = {
    COMMENT: 'comment',
    ENTER: 'enter',
    REPORT: 'report',
    ADD: 'added post'
} as const;
export type LogsType = typeof LOGSTYPE[keyof typeof LOGSTYPE];
export const PAGE_SIZE = 6;
export const mobile_card_height = 500;
export const regular_card_height = 700;

export const feed_regular_card_height = {xs:400, lg:700};
export const Languages = {
    English: 'English',
    Hebrew: 'Hebrew',
    Hindi: 'Hindi',
    French: 'French',
    Spanish: 'Spanish',
    Chinese: 'Chinese',
    Arabic: 'Arabic',
    Portuguese: 'Portuguese',
    Russian: 'Russian',
    Japanese: 'Japanese',
    Korean: 'Korean',
    Indonesian: 'Indonesian',
    Malay: 'Malay',
    German: 'German',
    Bengali: 'Bengali',
    Turkish: 'Turkish',
    Vietnamese: 'Vietnamese',
    Thai: 'Thai',
    Persian: 'Persian',
    Italian: 'Italian',
    Polish: 'Polish'
  };
 export const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: {xs:320, sm:500}, // Adjust the width as necessary
    bgcolor: 'background.paper', // This sets a non-transparent background
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
  
export const modalBackgroundStyle = {
    backdropFilter: "blur(3px)", // This will give a blur effect to the background
    backgroundColor: 'rgba(0, 0, 0, 0.5)', // This sets the modal overlay's background with some transparency
  };
  export const LanguageCodes: {[key: string]: string } = {
    en: 'English',
    he: 'Hebrew',
    hi: 'Hindi',
    fr: 'French',
    es: 'Spanish',
    zh: 'Chinese',
    ar: 'Arabic',
    pt: 'Portuguese',
    ru: 'Russian',
    ja: 'Japanese',
    ko: 'Korean',
    id: 'Indonesian',
    ms: 'Malay',
    de: 'German',
    bn: 'Bengali',
    tr: 'Turkish',
    vi: 'Vietnamese',
    th: 'Thai',
    fa: 'Persian',
    it: 'Italian',
    pl: 'Polish'
    // Add more mappings as needed
  };
  
let globalPostEmbeddingId = -1;
export const moveEmbedId = () =>{
    globalPostEmbeddingId ++;
    return globalPostEmbeddingId;
}
export const showEmbedId = () =>{
    return globalPostEmbeddingId;
}

export const REPORT_OPTIONS = [
    "Incorrect or Inaccurate Response Generation",
    "Other Response Quality Issues (please specify)",
    "Layout, Display or Design Issues",
    "Feedback or Suggestions for Improvement",
    "Other Technical Issues"
];

export const urls = 
[
'https://www.instagram.com/p/Cx00clqIrgE/?utm_source=ig_web_copy_link&igshid=MzRlODBiNWFlZA%3D%3D',
'https://twitter.com/historyinmemes/status/1720180772508704871',
'https://twitter.com/historyinmemes/status/1720180772508704871',]

export const TestPosts: Post[]=[
  {
      "id": 2,
      "url": "https://www.instagram.com/p/CyYWP4bICMu",
      "text": "Allah apna reham ferma 🤲\n\n#Palestine #Innocentpeople #Palestinianpeople #Gazaunderattack #FreeGaza"
  },
  {
      "id": 3,
      "url": "https://www.instagram.com/p/CyWqz0KSIl8",
      "text": "Link in bio to donate⚠️Trigger warning….Calling this a war crime is not enough. Israel is committing a genocide and USA & Canada are complicit. \n\nThey turned Gaza into an extermination camp.\nSpeak up to our governments before there’s none of us left.\n\n#ethniccleansing #palestine #israel #freepalestine #freeisrael #yisrael #israël #canadastandswithisrael #justintrudeau #jagmeetsingh #biden #gaza #freegaza #prayforgaza #gazaunderattack"
  },
  {
      "id": 4,
      "url": "https://www.instagram.com/p/CyTaJSpsYe_",
      "text": "A farewell beneath the rubble!\nوداع تحت الأنقاض !\n\n#GazaUnderAttack #غزه_تحت_القصف"
  }, {
    "id": 67,
    "url": "https://twitter.com/1318537581185896448/status/1713697652137726298",
    "text": "BREAKING| Israeli occupation fighter jets have just killed a number of civil defense members after bombing a civil defense station west of Gaza. https://t.co/rlE75QZxXD"
},
{
    "id": 68,
    "url": "https://twitter.com/1267418873177034753/status/1714164918973333610",
    "text": "Heart-wrenching: Palestinian father, oblivious to his own wounds, tends to his son’s lifeless body slaughtered by Israeli occupation missiles. \n\n#GazaGenocide #gazaunderattack https://t.co/QdpkFA5Euv"
},
{
    "id": 69,
    "url": "https://twitter.com/918082298/status/1714065048652435630",
    "text": "my aunt sent me this video from occupied khalil. israeli occupation soldiers invaded her neighbor’s home at 2:30 in the morning, handcuffed and blindfolded him before abducting him. they just abducted another neighbor. https://t.co/MB2KxWS4Ub"
},
{
    "id": 70,
    "url": "https://twitter.com/1541424185402081281/status/1714168542243836018",
    "text": "🔥FIRST ATACMS ATTACK ???🔥\n\nOn the night of October 17, the Armed Forces of Ukraine carried out successful strikes against helicopters and securing airfields of the Russian occupation forces in the vicinity temporarily occupied Luhansk and Berdyansk\n\n❗️MANAGED TO CAUSE… https://t.co/SSZftZLhYs"
},
  {
      "id": 6,
      "url": "https://www.instagram.com/p/CyRZDQnLEmD",
      "text": "الليل.. كلمة الرعب في #غزة !\nNight… a word of terror in #Gaza !\n\n#GazaUnderAttack #غزه_تحت_القصف"
  },
  {
      "id": 7,
      "url": "https://www.instagram.com/p/CyZSNHvhK1E",
      "text": "💔 Palestinian children writing their names and ID numbers on their hands to get identified after being bombed.\n.\n.\n.\n.\n.\n#تايبوغرافي #عبارة #مقولة #اقتباسات #اقتباس #خط  #تصميم  #فلسطين #غزة #غزة_تحت_القصف \n #palestine #posterdesign #poster #graphicdesigner #typeposter  #logodesigner #logo #arabictypography #illustrationdesign  #typography  #illustrator #photoshop #adobe  #arabicdesigner #digitalart #graphicdesign #illustrations #illustrationposter #palestine #gaza #gazaunderattack"
  }]
export const Allposts: Post[] = [
  {
      "id": 8,
      "url": "https://www.instagram.com/p/CyQwlbLsHi8",
      "text": "غزة.. حُكم بالإعدام !\n#Gaza is sentenced to death!\n#GazaUnderAttack #غزه_تحت_القصف"
  },
//   {
//       "id": 9,
//       "url": "https://www.instagram.com/p/CyRLExQLNt9",
//       "text": "🇵🇸🚨IT’S GENOCIDE🚨🇵🇸\n\n#freepalestine #palestine #gaza #palestinewillbefree #savepalestine #palestineunderattack #gazaunderattack #gazapalestine #gazastrip #gaza_under_attack #savegaza #france #usa #uk #brazil #mexico #india #saudiarabia"
//   },
//   {
//       "id": 12,
//       "url": "https://www.instagram.com/p/CyWNYf0gd18",
//       "text": "This is the history of genocide you read about in textbooks. God is watching. Be on the right side of history.\n\n#palestine🇵🇸 #palestine #gazaunderattack #gaza #genocide"
//   },
  {
      "id": 15,
      "url": "https://www.instagram.com/p/CyLRpsMseQ6",
      "text": "The occupation’s massacre of entire families and the bombing of homes over their inhabitants is an unceasing aggression in Gaza.\n\nمجازر الاحتلال بحق عائلات بأكملها وقصف البيوت فوق رؤوس ساكنيها عدوان لا يتوقف في غزة. \n#GazaUnderAttack #غزه_تحت_القصف"
  }, {
    "id": 67,
    "url": "https://twitter.com/1318537581185896448/status/1713697652137726298",
    "text": "BREAKING| Israeli occupation fighter jets have just killed a number of civil defense members after bombing a civil defense station west of Gaza. https://t.co/rlE75QZxXD"
},
// {
//     "id": 68,
//     "url": "https://twitter.com/1267418873177034753/status/1714164918973333610",
//     "text": "Heart-wrenching: Palestinian father, oblivious to his own wounds, tends to his son’s lifeless body slaughtered by Israeli occupation missiles. \n\n#GazaGenocide #gazaunderattack https://t.co/QdpkFA5Euv"
// },
{
    "id": 69,
    "url": "https://twitter.com/918082298/status/1714065048652435630",
    "text": "my aunt sent me this video from occupied khalil. israeli occupation soldiers invaded her neighbor’s home at 2:30 in the morning, handcuffed and blindfolded him before abducting him. they just abducted another neighbor. https://t.co/MB2KxWS4Ub"
},
{
    "id": 70,
    "url": "https://twitter.com/1541424185402081281/status/1714168542243836018",
    "text": "🔥FIRST ATACMS ATTACK ???🔥\n\nOn the night of October 17, the Armed Forces of Ukraine carried out successful strikes against helicopters and securing airfields of the Russian occupation forces in the vicinity temporarily occupied Luhansk and Berdyansk\n\n❗️MANAGED TO CAUSE… https://t.co/SSZftZLhYs"
},
  {
      "id": 16,
      "url": "https://www.instagram.com/p/CybOqsnNdpE",
      "text": "@T3Vakfi:\n\nEğitim, bilim ve teknolojiyle büyümesi gereken çocukların, bombalar altında insanlık dışı bir zulme maruz bırakılmasını şiddetle kınıyoruz!\n\nTürkiye Teknoloji Takımı Vakfı\n\n#GazaUnderAttack\n\nYüzyıllar boyunca insanların kardeşçe yaşadığı bir şehir, en temel insani ihtiyaçlardan yoksun bir açık hava hapishanesine dönüşmüş durumda. Masum insanların her gün bombardıman altında kaldığına ve tüm dünyanın gözü önünde insanlık suçu işlendiğine şahit oluyoruz!\n\nTürkiye Teknoloji Takımı Vakfı olarak bölgede bir an evvel barış ve huzurun temin edilmesi için çağrı yapıyoruz. Eğitim, bilim ve teknolojiyle büyümesi gereken çocukların, bombalar altında insanlık dışı bir zulme maruz bırakılmasını şiddetle kınıyoruz!"
  },
  {
      "id": 18,
      "url": "https://www.instagram.com/p/CyYvGrdqEtD",
      "text": "Duruşumuz Filistin’dir..\nDuruşumuz Gazze’dir..\n\nDuruşumuz zulme karşıdır..\nDuruşumuz iki yüzlü batıya karşıdır..\n\n#BüyükFilistinYürüyüşü\n#ÖzgürKudüs\n#FreeGaza"
  },
  {
      "id": 19,
      "url": "https://www.instagram.com/p/CyUFM1NAfo8",
      "text": "Another war crime confirmed. For days Palestinians have been reporting chemical reactions to the bombing. And now it’s confirmed Israel, with full US backing, is using chemical weapons on children all while preventing even water from Gaza. Despicable.\n\nRead more via link in bio. \n#palestine #palestine🇵🇸 #gazaunderattack"
  },
  {
      "id": 20,
      "url": "https://www.instagram.com/p/CyOKe2OMUP2",
      "text": "Al-Rimal Neighborhood... Israel turned it to ashes!\n\nحي الرمال.. أعاده الاحتلال رماداً !\n\n#GazaUnderAttack #غزه_تحت_القصف"
  },
  {
      "id": 21,
      "url": "https://www.instagram.com/p/CyThyRDIex0",
      "text": "قريبآ هيتقطع عن #الفلسطنين الانترنت محدش هيعرف عنهم اي حاجه تاني في نفس الوقت الطرف الأخر عنده كل حاجه وكل الميديا ومتحكمين في الميديا في العالم كله  Don’t stop talking about palastine \nهذا الحساب يدعم #القضية_الفلسطنية \n#فلسطين  #palastine  #palastine🇵🇸 \n#فلسطين_تحت_القصف_الإسرائيلي\n#dontstop_takling_about_palastine 🇵🇸"
  },
  {
      "id": 23,
      "url": "https://www.instagram.com/p/CyV1WCRoBG9",
      "text": "اللهم إنا نستودعك بيت المقدس وأهل #غزة 🤲🏼🇵🇸💔\nاللهم كن لأهل #فلسطين عوناً ونصيرًا ومؤيدًا وظهيرًا، وحافظًا وأمينًا…\nاللهم إنا لا نملك إلا الدعاء لهم يا ربّ لا ترد لنا دعاء وأنت أرحم الراحمين\n\n#istandwithpalestine"
  },
  {
      "id": 25,
      "url": "https://www.instagram.com/p/CyOf4UqrGQH",
      "text": "They escaped to safety… So they killed them \nفروا للنجاة.. فقتلهم !\n\n#GazaUnderAttack #غزه_تحت_القصف"
  },
  {
      "id": 26,
      "url": "https://www.instagram.com/p/Cyfd97_L6iz",
      "text": "The World is Silent, meanwhile, Israel is Committing War Crimes against the people of Gaza\n\n#AIMIM #AsaduddinOwaisi #Owaisi #Palestine #AlAqsa #Gaza #MasjideAqsa #IsraelGazaWar #GazaUnderAttack #gazagenocide"
  },
  {
      "id": 27,
      "url": "https://www.instagram.com/p/CyZGdaVLBIP",
      "text": "🇵🇸🚨IT’S GENOCIDE🚨🇵🇸\n\n#freepalestine #palestine #gaza #palestinewillbefree #savepalestine #palestineunderattack #gazaunderattack #gazapalestine #gazastrip #gaza_under_attack #savegaza #france #usa #uk #brazil #mexico #india #saudiarabia"
  },
  {
      "id": 28,
      "url": "https://www.instagram.com/p/CyZPutTs9Sh",
      "text": "You don't have to be a Muslim to support Palestine; you just have to be human! \n\n#freepalestine #غزة #gazaunderattack #gaza"
  },
  {
      "id": 31,
      "url": "https://www.instagram.com/p/CyRdbsIMGgT",
      "text": "This is the truth. Spread it. \n\n#freepalestine #gazaunderattack #freedom"
  },
  {
      "id": 32,
      "url": "https://www.instagram.com/p/CyUDmleND1L",
      "text": "May Allah (swt) protect our brothers and sisters ❤️‍🩹 \n\nDigital art by me 🤍\n\n.\n.\n.\n#islamicquotes #digitalart #palestine #palestine🇵🇸 #gaza #gazaunderattack #palestinians #quranquotes #quran #quranverses"
  },
  {
      "id": 35,
      "url": "https://www.instagram.com/p/CyO3xPHMT0d",
      "text": "“You don’t need to be a Muslim to stand up for Palestine, you just need to be a human” \n\nO Allah protect the people of Palestine \nO Allah ease their pain and suffering \nO Allah bestower of mercy ,bestow your mercy on them \nO Allah open people’s hearts to give in this time of crisis Amin 🙏 \nما يحدث في فلسطين لا يتحمله عقل بشري .. \nجرائم من ابشع ما يكون \nواستخدام اسلحة محرمة دوليا لقتل المدنين الاطفال والسيدات \nعدد حالات الضحايا تتعدي الالاف من اطفال لسيدات لرجال .. \n\"اللهم نصرك كما وعدت \" \n\"اللهم نصرك كما وعدت \" \n\"اللهم نصرك كما وعدت\" \nفلسطين قضيتنا وفي دمنا \n\"نحن اصحاب القضية \"\n#gazaunderattack \n#freepalestine \n#savepalestine \n#stopthewar 🔴\nفلسطين 🇵🇸"
  },
  {
      "id": 39,
      "url": "https://www.instagram.com/p/CyQ9G-Ltv88",
      "text": "Never choose silence!!!!!\n#gazaunderattack #gaza #standwithpalestine #palestine #freepalestine #landpalestine"
  },
  {
      "id": 41,
      "url": "https://www.instagram.com/p/CyOIpJeN1DK",
      "text": "Again and again!!!!\nWhat is happening in Palestine is not complicated; it's settler colonialism and ethnic cleansing. \nSwipe to learn about myths perpetuated by the mainstream media who has continuously worked to conceal Israel's ongoing genocide and ethnic cleansing of Palestine by saying it's a two-sided conflict, framing Palestinian resistance as terrorism and normalizing the state of Israel\n#standwithpalestine #gazaunderattack #gaza #palestne #jerusalem #freepalestine  #landpalestine"
  },
  {
      "id": 42,
      "url": "https://www.instagram.com/p/CyTIu_8NXSx",
      "text": "Come on, tell me who the oppressor is? Who is the oppressed? Who is the victim? Who is the perpetrator? \n#gazaunderattack #gaza #standwithpalestine #palestine #freepalestine #landpalestine"
  },
  {
      "id": 44,
      "url": "https://www.instagram.com/p/CyTpimwvRqI",
      "text": "नेपाल ने अपने 253 छात्रों को इज़राइल के तेल अवीव से एयरलिफ्ट किया। विदेश मंत्री एनपी सऊद ने विमान में सवार छात्रों का अभिनंदन किया। #Isarael #palastine #Nepal"
  },
  {
      "id": 45,
      "url": "https://www.instagram.com/p/Cybdla7tRfd",
      "text": "HAMAS = ISIS\n#hamasisisis #freegazafromhamas"
  },
  {
      "id": 46,
      "url": "https://www.instagram.com/p/CyTv6litXhp",
      "text": "#gazaunderattack"
  },
  {
      "id": 48,
      "url": "https://www.instagram.com/p/CyQ_5Ihs2Ay",
      "text": "#GazaSpeaksUp : Journalist Yafa Abu Akr, mother of 3 children - Gaza City.\n#غزة_تتحدث : الصحفية يافا أبو عكر أم ل3 أطفال - مدينة غزة\n\n#GazaUnderAttack #غزه_تحت_القصف"
  },
  {
      "id": 50,
      "url": "https://www.instagram.com/p/CyMkz_RLZWS",
      "text": "Ato em solidariedade ao povo palestino 🇵🇸\n\nTerça (10), Rio e São Paulo sediarão grandes atos em defesa da Palestina e contrários aos crimes contra a humanidade cometidos pelo Estado terrorista de Israel, cuja existência enquanto Estado teocrático e sionista já é uma afronta direta ao direito dos palestinos de existirem.\n\nA luta pelo fim do Estado de Israel é imediata, sendo a única possibilidade de haver paz entre os trabalhadores palestinos e israelenses.\n\nTodo apoio à Palestina 🇵🇸 \nFim do Estado de Israel 🇮🇱 \n\n#pco #hamas #palestinalivre #israelterrorista"
  },
  {
      "id": 51,
      "url": "https://www.instagram.com/p/CyWwu7GIWOv",
      "text": "This account supports the state of Palestine and does not recognize the Zionist entity\n\nهذا الحساب يدعم القضية الفلسطينية ولا يعترف بدولة إسرائيل.\n\n\"اللهُم إنّا لا نملك لهم إلا الدعاء فكن يارب عونًا لهم وانصرهم على القوم الظالمين ، اللّهُمّ إنا نستودعك غزة وأهلها .\" 🇵🇸\n\n#فلسطين #القدس\n#palestine #freepalestine \n#gazaunderattack"
  },
  {
      "id": 52,
      "url": "https://www.instagram.com/p/CyTbCCeOGL9",
      "text": "May Allah help and protect the people of Palestine 🤲🏻🇵🇸 #freepalestine \n\n#freedomforpalestine #prayforpalestine #palestinelivesmatter \n#westandwithpalestine #palestinewillbefree \n#savealaqsa #savepalestine \n#gazaunderattack \n#alaqsaunderattack #explore #exploremore #exploring #islam #islamic #islamicquotes #islamicreminders #islamicpost #allah #allahuakbar #allahﷻ #followme #followforfollowback"
  },
  {
      "id": 54,
      "url": "https://www.instagram.com/p/CyQgJkkM3FQ",
      "text": "نزوح تحت النار!\n Displacement under fire!\n\n#GazaUnderAttack #غزه_تحت_القصف"
  },
  {
      "id": 55,
      "url": "https://www.instagram.com/p/CyWEVX-IlYB",
      "text": "#Israel dropped 6,000 bombs on #Gaza Strip in six days, the same amount the U.S dropped on #Afghanistan in one year!\n\nAfghanistan is 1811 times as big as the Gaza Strip!\n\nFollow @doamuslims\nBackup Page @doamuslims2 \n#Islam #Ummah #Muslims #Palestine #Palestinians #palestine🇵🇸 #palestineforever #MasjidAlAqsa #AlAqsa #AlQuds #AlAqsaMosque #Muslim #Палестина #فلسطين #Hijab #Hijabi #Niqabi #Muslimah #hijabers #Quran #gazaunderattack"
  },
  {
      "id": 56,
      "url": "https://www.instagram.com/p/CyS0I6VyrpM",
      "text": "The Israeli Defense Minister earlier announced an abolition of all rules of war. This is a war crime.\n\n#freepalestine #freegaza"
  },
  {
      "id": 61,
      "url": "https://twitter.com/1066392792715399171/status/1713668428563656724",
      "text": "Father of Muhammad al-Durrah, whose son was executed in his lap by the lsraeli occupation forces 23 years ago, bids farewell today to a number of his family members who were killed in the lsraeli air attacks. https://t.co/n1v7zLSuGy"
  },
  {
      "id": 62,
      "url": "https://twitter.com/462312323/status/1714238063080009879",
      "text": "🎙️ Eric Cantona: “Defending Palestinian human rights does not mean you are pro-Hamas. Saying “Free Palestine” does not mean that we are anti-Semitic or that we want the disappearance of all Jews.\n\n“Free Palestine” means freeing Palestinians from the Israeli occupation that has… https://t.co/B4KJqzYqF0"
  },
  {
      "id": 63,
      "url": "https://twitter.com/1066392792715399171/status/1713925444934795696",
      "text": "Handcuffed and blindfolded, lsraeli occupation forces detain a number if Palestinians and torture them with loud music. https://t.co/hPB2LrevTp"
  },
  {
      "id": 64,
      "url": "https://twitter.com/1318537581185896448/status/1713843513043890202",
      "text": "Palestinian civil defense crews pull out a child's body from the rubble of his home after being bombed by Israeli occupation jets in Khan Younis city, #Gaza. https://t.co/ZTJReCtXpo"
  },
  {
      "id": 65,
      "url": "https://twitter.com/2268541258/status/1711836352470257738",
      "text": "Two years later, everything I said in this interview is still true.\nHamas has not achieved anything on behalf of the Palestinian people — it simply holds Palestinians hostage while promoting terror.\n#FreeGazaFromHamas https://t.co/9yXw2y0cYe"
  },
  {
      "id": 66,
      "url": "https://twitter.com/112233124/status/1713994257843802605",
      "text": "English version 🧵\n\nMaybe you don't know the story of the child in the picture, but for sure you have seen his picture before, another crime for the occupation that never ends against the Palestinian people. This time, the victim is a child born in 2002 in Jerusalem.. https://t.co/5K39VwjNdZ"
  },

  {
      "id": 71,
      "url": "https://twitter.com/20591678/status/1713528910694993924",
      "text": "Shai Davidai, Israeli Professor at Columbia university: they won’t allow a pro-ISIS rally or a pro-KKK rally, yet when when it comes to Israeli and Jewish lives, they allow a pro-Hamas rally.\n \n#HamasisISIS #FreeGazaFromHamas https://t.co/uHLkXgGVXh"
  },
  {
      "id": 72,
      "url": "https://twitter.com/1318537581185896448/status/1714235983967760880",
      "text": "The Israeli occupation forces have arrested Dr. Dalal Abu Amneh, the Palestinian artist and researcher in the field of brain sciences and neurophysiology.\n\nDalal was arrested due to a post she shared on her Facebook account, in which she expressed her condemnation of the ongoing… https://t.co/1UIB833THP"
  },
  {
      "id": 73,
      "url": "https://twitter.com/16314859/status/1713618353682604159",
      "text": "HAMAS = ISIS\n#HamasisISIS #FreeGazaFromHamas https://t.co/PnutywQrs9"
  },
  {
      "id": 74,
      "url": "https://twitter.com/1318537581185896448/status/1713891122810884280",
      "text": "Aerial photos show #GazaCity towns before the israeli occupation airstrikes on it and after! https://t.co/LAZ03GA4bc"
  },
  {
      "id": 75,
      "url": "https://twitter.com/848279118/status/1713699259621523603",
      "text": "WATCH: \n\nRemember this video?\n\nIt was in the year 2000, the Israeli Occupation Forces shot 12 year old Muhammad Al Durrah to death as his father (Jamal al-Durrah) tried to shield him.\n\nToday, Jamal lost 2 more of his children due to an Israeli airstrike on Gaza.\n\nThe first video… https://t.co/xYQmaBsOfN"
  },
  {
      "id": 76,
      "url": "https://twitter.com/110396781/status/1713888016622841928",
      "text": "This is what life is like for a Palestinian child living under Israeli occupation: https://t.co/YFXd1vuI1D"
  },
  {
      "id": 77,
      "url": "https://twitter.com/1564608943099355141/status/1713813893397508577",
      "text": "\"Hamas is a resistance (group) confronting 75 years of occupation and colonialism\"\n\nThe Israeli reporter was left speechless as a Canadian citizen educated him on certain historical facts and debunked some fake news. https://t.co/bnnC3q08xn"
  },
  {
      "id": 78,
      "url": "https://twitter.com/178095380/status/1713993666203660418",
      "text": "not settlement!\noccupation!\n#zionistterror https://t.co/lyHhK1sE4C"
  },
  {
      "id": 79,
      "url": "https://twitter.com/16314859/status/1713539705482912255",
      "text": "Enough said. \n\n#StandWithIsrael \n#FreeGazaFromHamas\n#HamasMassacre\n#HamasIsISIS\n@RepDeanPhillips https://t.co/vo32lCqK8z"
  },
  {
      "id": 80,
      "url": "https://twitter.com/16314859/status/1713545046098641087",
      "text": "...Just saying.\n\n#FreeGazaFromHamas\n#HamasIsISIS https://t.co/PcA3XsRNUU"
  },
  {
      "id": 81,
      "url": "https://twitter.com/2155425056/status/1713967502483661227",
      "text": "@ionebelarra BOLD statement from UK MP @jeremycorbyn :\n\n\"We will carry on demonstrating as long as it takes to stop the bombardment of Gaza, to end the occupation, and to bring about a just and lasting peace.\" https://t.co/PYupsuayEL"
  },
  {
      "id": 82,
      "url": "https://twitter.com/1964862775/status/1714230177532617135",
      "text": "Israeli journalist Gideon Levy at the Oxford Union several years ago: \n\n‘There is no Israeli-Palestinian conflict. There is a brutal Israeli occupation which must come to its end one way or the other’ https://t.co/L5YdDPIzWC"
  },
  {
      "id": 83,
      "url": "https://twitter.com/2268541258/status/1686093791680229376",
      "text": "In a rare public display of discontent with the Hamas regime, thousands of Gazans protested difficult living conditions and call for the removal of Hamas from power. Hamas security officers used force, including live fire, to disperse the protests.\n#FreeGazaFromHamas https://t.co/wVMl0zjoo0"
  },
  {
      "id": 84,
      "url": "https://twitter.com/16314859/status/1713958041425461482",
      "text": "Still think that #Hamas is fighting FOR the sake of #Palestinians? \nThink again. \n\n#FreeGazaFromHamas\n#HamasIsISIS https://t.co/wfmpyY34Aw"
  },
  {
      "id": 85,
      "url": "https://twitter.com/524869533/status/1714183488759353609",
      "text": "Media coverage: \"The bereaved mother of #Palestinian youth Nidal Melhem bids a final farewell to her son, who was murdered by Israeli occupation forces' gunfire this morning in the town of Halhul, south of the occupied West Bank.\" https://t.co/DcsAIbSW3l"
  },
  {
      "id": 86,
      "url": "https://twitter.com/580033481/status/1429158613378084870",
      "text": "An Israeli soldier is fighting for his life after being shot in the head from point blank range during a violent demonstration today in #Gaza.\n\nBut media reports insist on describing these incidents as \"protests\".\n\n#FreeGazaFromHamas\n\n#GazaUnderAttack #Hamas #Israel https://t.co/atyHGrwxXL"
  },
  {
      "id": 87,
      "url": "https://twitter.com/524869533/status/1714168740856651853",
      "text": "Media coverage: \"Israeli occupation forces raid a #Palestinian shop in occupied Jerusalem, force the vendor to open his phone to check whether there are posts supporting Gaza, subsequently arresting him.\" https://t.co/KwLq9dO9Ig"
  },
  {
      "id": 88,
      "url": "https://twitter.com/1392864463204782082/status/1714276406002438432",
      "text": "⚡️A new massacre carried out by the occupation forces on the Bureij refugee camp in the central Gaza Strip https://t.co/9BLGUjM06E"
  },
  {
      "id": 89,
      "url": "https://twitter.com/51913011/status/1714263330754273611",
      "text": "Fathi Hamad is the Hamas political chief and a member of the Palestinian Legislative Council. His goal is not to \"free Palestine.\" It is not to end the \"occupation.\" It is not \"national liberation.\"\n\nIt is to shed as much Jewish blood as possible. Period. https://t.co/4bVZt9YWvs"
  },
  {
      "id": 90,
      "url": "https://twitter.com/1318537581185896448/status/1714250529168073096",
      "text": "Israeli occupation warplanes bombed residential buildings in Rafa city, Gaza. https://t.co/iSbbcIlz9n"
  },
  {
      "id": 91,
      "url": "https://twitter.com/1121807798826930177/status/1714172789760954511",
      "text": "🇵🇸🇮🇱🚨‼️ Palestinian media reports; \"Israeli occupation forces raid a Palestinian shop in occupied Jerusalem, force the vendor to open his phone to check whether there are posts supporting Gaza, subsequently arresting him.\" https://t.co/iEYhuSoYxg"
  },
  {
      "id": 92,
      "url": "https://twitter.com/203348714/status/1712388348923503067",
      "text": "The footage from Gaza are heartbreaking, praying for all the innocents caught up in Hamas mess and for the war to be over! I know what’s like to be dragged to a war by corrupt gov. Hamas should surrender if they truly cared about the welfare of Palestinians. #FreeGazaFromHamas https://t.co/JRerUjvW4l"
  },
  {
      "id": 93,
      "url": "https://twitter.com/2258963714/status/1713981055135277285",
      "text": "🚨ISRAEL LIES AGAIN🚨\n\nThe Israeli occupation said it would allow some aid to enter Gaza. Then it broke its word and bombed the Egypt-Gaza Rafah border crossing once again.\n\nThis time they bombed the Egypt side of the border, but what will Egypt do about it? Nothing. #Palestine https://t.co/C5Qogh6rCT"
  },
  {
      "id": 94,
      "url": "https://twitter.com/1267097352847925248/status/1714196142123082078",
      "text": "هذه غزة .. يا أمة المليار\n#مجلس_الأمن #الأردن #غزة_تزحف_الى_القدس #غزة_تُباد #معبر_رفح #الإجتياح_البري \n#مع_غزة_المقاومة #غزة_الآن #غزه_تحت_القصف #غزه_تقاوم #إبن_اليهودية #حماس_منا_ونحن_منها #الصهاينة_العرب #FreePaleastine #FreeGazaFromHamas #PalestineLivesMatter #ZionistTerror https://t.co/JGy5vmxjXC"
  },
  {
      "id": 95,
      "url": "https://twitter.com/820411862026190848/status/1714208814495301993",
      "text": "A wide arrest campaign in the West Bank..\n\nHead of the Palestinian Parliament, Aziz Dweek and other 108 Palestinians arrested by the Israeli occupation forces. 25% of them are children &amp; elderly https://t.co/CW0vBX3Mc9"
  },
  {
      "id": 96,
      "url": "https://twitter.com/47316091/status/1713630607173963986",
      "text": "A wonderful dignified vigil of well over 500/600 people in Dublin for the victims of Hamas terror . Calls to free the kidnapped &amp; prayers for all the innocent people in the region.  #dublin #proIsrael #Hamas_is_ISIS #FreeGazaFromHamas #Ireland https://t.co/TnVZSyi14u"
  },
  {
      "id": 97,
      "url": "https://twitter.com/16314859/status/1713530821477359638",
      "text": "#FreeGazaFromHamas\n#HamasIsISIS https://t.co/y3TKf4z5KN"
  },
  {
      "id": 98,
      "url": "https://twitter.com/524869533/status/1713891150971424960",
      "text": "BREAKING: Israeli occupation soldiers open gunfire on a Palestinian vehicle near the village of Al-Hijra, south of Hebron in the occupied West Bank. https://t.co/a9TOMbH21q"
  },
  {
      "id": 99,
      "url": "https://twitter.com/2258963714/status/1714224832856936514",
      "text": "A Palestinian doctor busy treating children who were just bombed by the Israeli occupation suddenly realises that it's his own family and relatives whose homes have been bombed 💔 it's difficult to imagine what they must be going through #GazaGenocide 🇵🇸 https://t.co/61DqctfxCQ"
  },
  {
      "id": 100,
      "url": "https://twitter.com/1505982614875877386/status/1714035237280268368",
      "text": "This was Life in Palestine prior to the ILLEGAL Zionist Occupation \n\nLook how peaceful it was. https://t.co/GR3Zap7TF2"
  },
  {
      "id": 101,
      "url": "https://twitter.com/1012443708/status/1712457442749989356",
      "text": "Hamas is to blame\n\n#FreeGazaFromHamas \n\n https://t.co/SVFfHJtGGD"
  },
  {
      "id": 102,
      "url": "https://twitter.com/2373735295/status/1713907676856402403",
      "text": "While speaking on Sky News on Sunday, journalist Rachel Shabi urged people to consider the wider context behind the support of Hamas, highlighting how political attempts to end Israel's occupation of Palestine were “blocked by the international community.” https://t.co/5rrpJkdmFj"
  },
  {
      "id": 103,
      "url": "https://twitter.com/16314859/status/1713623275354362167",
      "text": "Terror group #Hamas prevents #Palestinians from fleeing Northern #Gaza. Here is why: #HamasisISIS #FreeGazaFromHamas #HamasMassacre https://t.co/Z8Z0TeDTep"
  },
  {
      "id": 104,
      "url": "https://twitter.com/2268541258/status/1711430106344734974",
      "text": "A Hamas rocket hit a mosque in Abu Ghosh.\nHamas continues to fire rockets indiscriminately at civilian areas. They don't care who they kill.\n#FreeGazaFromHamas https://t.co/PwkcF4uzLo"
  },
  {
      "id": 105,
      "url": "https://twitter.com/282670739/status/1673999259887190016",
      "text": "According to the United Nations, using children in a military conflict is a war crime.\n\nChildren are being forced to learn to kill in Hamas 'summer camps'  (funded by Iran) across Gaza.  There is no UN outrage.\n\nI hope your children enjoy the summer!\n\n#FreeGazaFromHamas https://t.co/pNzxNx12WQ"
  },
  {
      "id": 106,
      "url": "https://twitter.com/1443502889499045889/status/1712754253226246581",
      "text": "🚨🇮🇱🇵🇸 ALERTE : Les #Jordaniens ont franchi le cordon militaire et se dirigent vers la frontière avec #Israël.\n\n@BFMTV @LCI #Gazaouis #FreeGaza #FreeGazaFromHamas #Hamas \n#Gaza #Gaza_under_attack \n#palastine #Palestine #Israel_under_attack \n\n https://t.co/hbdgDPuav4"
  },
  {
      "id": 107,
      "url": "https://twitter.com/1012443708/status/1713197121933889976",
      "text": "This is how Hamas uses children.\n\nThey burn infants in their sleep and send children to the front line while their commanders are fattening themselves in luxury hotels in Qatar \n\nHamas is responsible for the whole situation \n\n#FreeGazaFromHamas https://t.co/wx9l4OjAow"
  },
  {
      "id": 108,
      "url": "https://twitter.com/2373174403/status/1714256277587587418",
      "text": "Hello Gaza. #FreeGazaFromHamas https://t.co/IXwW3DArUx"
  },
  {
      "id": 109,
      "url": "https://twitter.com/1247200900122398720/status/1712759865876091110",
      "text": "Huge crowd gather in Tahir Square in the capital, Bangladesh, in support of Palestine 🇵🇸 and in rejection of the occupations aggression against #Gaza \n\n#Israel  #FreeGazaFromHamas #LahoreProtest #GazaUnderAttack #IsraelTerrorists #Gaza  #Hamas\n#BoycottMcDonalds https://t.co/O82GtcUJq7"
  },
  {
      "id": 110,
      "url": "https://twitter.com/524869533/status/1714278696532767146",
      "text": "A merchant sends a message to the world from the Rimal neighborhood in Gaza: “We were born to resist the occupation. We are steadfast and will not migrate and leave our land”.  #Gaza #Palestine https://t.co/i09mz50TCT"
  },
  {
      "id": 111,
      "url": "https://twitter.com/441212043/status/1714282840698032472",
      "text": "A new massacre carried out by the occupation forces on the Bureij refugee camp in the central Gaza Strip"
  },
  {
      "id": 112,
      "url": "https://twitter.com/1298349652203524097/status/1713169600127414282",
      "text": "London now 🇵🇸🇵🇸\n\n#Gazagenocide #IsraelTerrorists #مقاطعة_ماكدونالدز #علامات_الظهور #غزة_الآن #غزه_تحت_القصف_القدس_تنتفض #طوفان_الاردن #فلسطين_تقاوم #فلسطين #فلسطين_المحتلة #فلسطين_حرة #FreeGaza #FreePalaetine #FreePalaestine #FreeGazaFromHamas #غزة_الآن #غزة_تُباد #فلسطين_حرة https://t.co/h2YYalaZj1"
  },
  {
      "id": 113,
      "url": "https://twitter.com/1092843402490798085/status/1714237921807540539",
      "text": "People of Israel,\nYour government has lied to you, and brought this bloodshed upon you themselves.\nWhere was your army?\nCall your corrupt leaders to end the occupation and corruption. https://t.co/UEXxtSeTdH"
  },
  {
      "id": 114,
      "url": "https://twitter.com/2348377081/status/1713919785698832550",
      "text": "The occupation forces have killed more than 1,030 Palestinian children since October 7.\n\nAt the rate of a child killed every 15 minutes 💔💔💔💔💔\n\nhttps://t.co/01qVLzs6Y4\n\n #OpenRafahCrossing\n#ادخال_المساعدات_لغزة"
  },
  {
      "id": 115,
      "url": "https://twitter.com/1320050125050421258/status/1714240478294487443",
      "text": "See how the #Israeli occupation changed the #Palestinian map since 1927. https://t.co/Pyh26J1c0y"
  },
  {
      "id": 116,
      "url": "https://twitter.com/16314859/status/1714020656986144945",
      "text": "If you care about #Palestinian civilians in #Gaza, you MUST wholly and unequivocally condemn #Hamas.\n\n#FreeGazaFromHamas\n#HamasIsISIS\n\nVia: @cogatonline https://t.co/n4TAEJZIKK"
  },
  {
      "id": 117,
      "url": "https://twitter.com/1647653785689288707/status/1713616200641479035",
      "text": "The facts\n\n#Every_Palestinian_is_oppressed #FreeGazaFromHamas #جاهزون_يا_فلسطين #غزة_تزحف_الى_القدس https://t.co/aEo7PHgoFQ"
  },
  {
      "id": 118,
      "url": "https://twitter.com/1264842314498756610/status/1712044294381461668",
      "text": "This video is from London a few years ago, \nA Muslim woman bravely defends a Jewish family.\n#PalestineUnderAttack #HamasMassacre #طوفان_الأقصى #غزة_الآن #Israel #Gaza #GazaUnderAttack #FreePalestine #FreeGaza #FreeGazaFromHamas https://t.co/LnzkTlfAAd"
  },
  {
      "id": 119,
      "url": "https://twitter.com/1464561877028114438/status/1713991649968181260",
      "text": "Final goodbye! \n\nA Palestinian dad hugging his baby after he got killed by Israeli occupation air strikes on Gaza https://t.co/XKUBguuOF0"
  },
  {
      "id": 120,
      "url": "https://twitter.com/1600030509664460802/status/1713249493808828457",
      "text": "Are you sure that you really want to stand with Palestine????? Maybe this video will change your mind.\n#WeStandWithIsrael #Hamas_is_ISIS #hamasiISIS #Hamas #FreeGazaFromHamas #FreePalastinefromhamas #FreePalaestine 🇮🇱🇺🇸🇮🇱🇺🇸🇮🇱🇺🇸🇮🇱🇺🇸🇮🇱 https://t.co/SVXMPpEz06"
  },
  {
      "id": 121,
      "url": "https://twitter.com/1972226910/status/1714190714244833786",
      "text": "Everywhere there are martyrs, the occupation's involvement in violence has led to the death of over 1,200 children in just 11 days. Is this the humanity we should discuss? Can children be labeled as terrorists? What justifies their suffering? #GazaAttack https://t.co/FVTaWqEkeu"
  },
  {
      "id": 122,
      "url": "https://twitter.com/172425386/status/1714280348811751719",
      "text": "With the attendance of diplomatic community, Fuzuli residents are rejoicing Fuzuli City Day - 17 October. On this particular day, in 2020, Fuzuli was liberated from 30 years long military occupation of Armenia. Former IDPs and refugees are returning to newly built apartments, and… https://t.co/nbsadRmXGn"
  },
  {
      "id": 123,
      "url": "https://twitter.com/1247200900122398720/status/1712735925900357780",
      "text": "Short Film 🇵🇸\nThe image is clear,\njust needs to be seen.\n\n#FreeGaza\n#Israel  #FreeGazaFromHamas #IsraelPalestineConflict #طوفان_الأقصى #طوفان_الاقصى_ #فلسطين #غزه_تباد  #GazaUnderAttack #IsraelTerrorists #Gaza #IsraelFightsBack #Hamas https://t.co/gM2ATs8II9"
  },
  {
      "id": 124,
      "url": "https://twitter.com/1414620597745766405/status/1714034869376889201",
      "text": "This little infant is now parentless after Israeli occupation warplanes targeted and bombed her family's house in Gaza.\n\nThe fate of her parents isn't known yet. They're maybe buried under the rubbles! https://t.co/bW6oZCYxUh"
  },
  {
      "id": 125,
      "url": "https://twitter.com/1683708205086674946/status/1713227552763085219",
      "text": "And 700 Palestinian children killed don't outrage you anymore, do they?\n\n#palastine #Palestine #FreeGaza #FreeGazaFromHamas #Israel #IsraeliWarCrimes #IsraelTerrorists https://t.co/CFJwCDqtZZ"
  },
  {
      "id": 126,
      "url": "https://twitter.com/941705260846010368/status/1712457144887341193",
      "text": "Hamas is a terror organization.\nThey do not care about the life of Israelis nor the life of its own people, the Palestinians.\n\nThey only care about preserving their power, no matter the cost. \n\n#HamasisISIS #FreeGazaFromHamas https://t.co/B4pfnyIyEM"
  },
  {
      "id": 127,
      "url": "https://twitter.com/3427754325/status/1712856816256696474",
      "text": "You want to #FreePalestine? Then #FreeGazaFromHamas https://t.co/PC4PADRAgp"
  },
  {
      "id": 128,
      "url": "https://twitter.com/4927593075/status/1714000614902923473",
      "text": "Humanitarian aid...\nThey live to kill!\n#hamasterrorists #HamasisISIS #freegazafromhamas #standwithisrael #letidfwin https://t.co/xlk8OC9A5K"
  },
  {
      "id": 129,
      "url": "https://twitter.com/18475861/status/1711838127424237996",
      "text": "Which side are you on? Humanity Or Hamas\n\n#Israel_under_attack\n#Israel #Gaza\n#HamasisISIS\n#HamasMassacre\n#FreeGazaFromHamas https://t.co/x5imQnzhSg"
  },
  {
      "id": 130,
      "url": "https://twitter.com/1261187841327054850/status/1714248013592313881",
      "text": "See how the isr*eli occupation changed the Palestinian map since 1927. https://t.co/CJ5SOz7jmd"
  },
  {
      "id": 131,
      "url": "https://twitter.com/1383911266658385924/status/1713471438336737525",
      "text": "➖SPEAK FOR THE :\n\n➖TRUTH' \n➖JUSTICE \n➖HUMANITY \n\n➖SPEAK up FOR :- #FreePalastine \n\n#FreeGazaFromHamas\n\n#IsraeliWarCrimes #KSIFury\n#IsrealPalestineconflict #Palestine\n#Gaza_under_attack #Israel\n#IsraeliWarCrimes #fixed\n #gazza #Gazagenocideشاركونا\n#อิสราเอลฮามาส #insiders… https://t.co/L5o1UYijHz"
  },
  {
      "id": 132,
      "url": "https://twitter.com/1683708205086674946/status/1714141592414785688",
      "text": "This occupation never was and NEVER will be about Jew vs. Muslim. REAL Jews are ANTI-ZIONISTS, because they KNOW that ZIONISM is AGAINST JUDAISM.   \n#IsraelGazaWar #GazaAttack #GazaCity #zionistterror #IsraeliNewNazism\n#PalestineGenocide #palastine #FreePalestine #FreeGaza… https://t.co/tkF6y6rosl"
  },
  {
      "id": 133,
      "url": "https://twitter.com/464853072/status/1713053930639294582",
      "text": "No one should justify the horrors executed by Hamas. \n\nHamas is the enemy of the people of Gaza.\n\n#FreeGazaFromHamas \n#Hamas_is_ISIS \n#HamasislSIS \n#TrueCrime \n#Gazagenocide \n\nhttps://t.co/JKMOxn07Nc"
  },
  {
      "id": 134,
      "url": "https://twitter.com/220776068/status/1714151855607959965",
      "text": "Iranian Foreign Minister Abdollahian:\n\n “The expansion of the war only to the resistance countries will create a situation that will change the geographical map of the occupation regime of Jerusalem.\n The Americans cannot constantly send the signal that they do not want the war… https://t.co/91lWhxRgEO"
  },
  {
      "id": 135,
      "url": "https://twitter.com/219433787/status/1714033607365292367",
      "text": "Gaza Strip workers, from inside the National Security Forces camp in Jericho.\n.\nAfter the occupation tore up their work permits and threw them into the West Bank https://t.co/LiDkUmyw9x"
  },
  {
      "id": 136,
      "url": "https://twitter.com/46856983/status/1713821337544724922",
      "text": "Bags of bullets instead of rice: Israel's SWAT unit, which eliminated 200 Hamas terrorists, discovered ammo in humanitarian aid. \nThe world must know that #Hamas is using their donations to smuggle ammo.\n#HamasIsISIS #FreeGazaFromHamas #Gaza #TheRealImage\n https://t.co/AN5cxYxc38"
  },
  {
      "id": 137,
      "url": "https://twitter.com/17874999/status/1713436656458498220",
      "text": "18 Israeli children have been kidnapped by Hamas.\n\nIf you want the suffering in Gaza to stop - give us back our children.\n\n #FreeGazaFromHamas\n#Hamas_is_ISIS \n\n https://t.co/ZoZpNd0SwB"
  },
  {
      "id": 138,
      "url": "https://twitter.com/1686222213513412608/status/1712011648662114513",
      "text": "Stand with us on the right side of history!\n\n#HamasisISIS\n#NeverAgainNow\n#FreeGazaFromHamas\n\n https://t.co/MihBW059P1"
  },
  {
      "id": 139,
      "url": "https://twitter.com/18475861/status/1711848135419371534",
      "text": "Hamas terrorists took over a residential home with a family and children and live-streamed it on Facebook \n\n#Gaza_under_attack \n#Gazastreifen \n#GazaTerror \n#Israel_under_attack\n#Israel #Gaza\n#HamasisISIS\n#HamasMassacre\n#FreeGazaFromHamas https://t.co/BpeKQPCnTz"
  },
  {
      "id": 140,
      "url": "https://twitter.com/352660013/status/1714230136587841975",
      "text": "A young man with special needs was injured in the Israeli occupation's shelling of the Gaza Strip. https://t.co/6zyRHfST0c"
  },
  {
      "id": 141,
      "url": "https://twitter.com/1647653785689288707/status/1713069212443259126",
      "text": "The Israelis' lies are exposed in a short video that does not exceed 1:13 minutes\n\n#Every_Palestinian_is_oppressed #Gazagenocide #FreeGazaFromHamas #اطفال_غزة_تحت_القصف_الاسرائيلي #طوفان_الاقصى #طوفان_الاردن https://t.co/HBPtd0e32M"
  },
  {
      "id": 142,
      "url": "https://twitter.com/282670739/status/1674697428853719042",
      "text": "Within Gaza, Palestinian terrorists kill Gazan civilians everyday. There is no acknowledgement or apology to the families of those murdered.\n\nThis is the real Gaza, Palestinians do not want the world to see.\n\nStop killing Gazans.\n\n#FreeGazaFromHamas https://t.co/ZhlvVk4Kfs"
  },
  {
      "id": 143,
      "url": "https://twitter.com/1535268491741339651/status/1712843510779429327",
      "text": "Malaysia stands in solidarity with Palestine 🇵🇸\n\n#FreePalestine #جمعة_طوفان_الأقصى #FreeGaza #FreeGazaFromHamas https://t.co/ybDJMhl6ij"
  },
  {
      "id": 144,
      "url": "https://twitter.com/1325872531279056897/status/1712883465555742814",
      "text": "@SharonaMazalian @DouglasKMurray You don't have to agree with every Israeli policy to condemn the massacre of innocents. No political stance justifies violence against children, women, and men. #StandWithIsrael #FreeGazaFromHamas https://t.co/PHDCe8OHE9"
  },
  {
      "id": 145,
      "url": "https://twitter.com/1267097352847925248/status/1714191141111771296",
      "text": "#ألمانيا  تعلن دعمها للكيان الصهيوني وتقمع الاحتجاجات المتضامنة مع فلسطين في معظم أنحاء البلاد \n#مع_غزة_المقاومة #غزة_الآن #غزه_تحت_القصف #غزه_تقاوم \n#إبن_اليهودية #حماس_منا_ونحن_منها #الصهاينة_العرب #FreePaleastine #FreeGazaFromHamas #PalestineLivesMatter #Israel #ZionistTerror https://t.co/GLXPdC8erz"
  },
  {
      "id": 146,
      "url": "https://twitter.com/4604479876/status/1714248353712624123",
      "text": "𝗜𝗦𝗥𝗔𝗘𝗟 𝗖𝗟𝗔𝗜𝗠𝗦 𝗙𝗔𝗞𝗘 𝗗𝗘𝗔𝗗 𝗕𝗔𝗕𝗜𝗘\n‼️𝗣𝗔𝗟𝗘𝗦𝗧𝗜𝗡𝗘 𝗜𝗦 𝗦𝗛𝗢𝗪𝗜𝗡𝗚 𝗬𝗢𝗨 𝗧𝗛𝗜𝗘𝗥 𝗠𝗨𝗥𝗗𝗘𝗥𝗘𝗗 𝗕𝗔𝗕𝗜𝗘𝗦‼️\n\nRescuing newborn babies from under the rubble as a result of the devastating Israeli occupation force bombing in the #Gaza Strip https://t.co/I7UACeRbGr"
  },
  {
      "id": 147,
      "url": "https://twitter.com/1320050125050421258/status/1714276544854798522",
      "text": "It's all about humanity.\n\nA number of Jews show their opposition to the Israeli occupation. #FreePalestine https://t.co/P1efBDfXvM"
  },
  {
      "id": 148,
      "url": "https://twitter.com/361833425/status/1712413694469013933",
      "text": "If you support the #Palestinian people you should be the first to condemn #Hamas!\nDo you belive that most Palestinians would behead babies? Shoot old women in the head? Burn people alive just for fun?????\nI don't.\n#freeGazafromHamas\n#HamasWarCrimes\n#HamasMassacre https://t.co/e1if7kJiRk"
  },
  {
      "id": 149,
      "url": "https://twitter.com/1461290481980162060/status/1712514454154346617",
      "text": "When a dog (gorgeous, innocent, brave, loyal dog) is more human then hamas man\n#HamasMassacre \n#HamasWarCrimes \n#FreeGazaFromHamas https://t.co/uRMpp69drc"
  },
  {
      "id": 150,
      "url": "https://twitter.com/219433787/status/1714262508041634070",
      "text": "The occupation targets the outskirts of the town of Al-Bustan, south of Lebanon, with artillery shells. https://t.co/CRVcfSKOM5"
  },
  {
      "id": 151,
      "url": "https://twitter.com/1438873890747392007/status/1712512198634013162",
      "text": "Heart-wrenching images depicting one of the tragedies in Gaza.\n\nSTOP THE WAR 🚨\n#GhazaUnderAttack #IsraelPalestineConflict #Gaza  #OperationAjay #Istandwithisreal #palastine #FreeGazaFromHamas #Isarael #IsraelFightsBack\n#IsraelTerrorists \nFrom: @Sahilsa29 https://t.co/IKw6UAWFSl"
  },
  {
      "id": 152,
      "url": "https://twitter.com/220347418/status/1713671237086359937",
      "text": "All you pro Palestinian supporters who have been orgasmic over the past week over #Hamas ‘resistance’ listen to Abu for the truth about your heroes. #HamasMassacre #FreeGazaFromHamas #StandWithIsrael"
  },
  {
      "id": 153,
      "url": "https://twitter.com/2875388958/status/1712694839148441905",
      "text": "Breaking: Egypt has refused to admit a single refugee from Gaza just like every other Arab nation and Iran. \n\nIsreal Friday the 13th Gaza and Lebanon Argentina Hamas \n#IsraelFightsBack \n#Hamas_is_ISIS #FreeGazaFromHamas \n#FreeGaza https://t.co/UsNNcmKcdQ"
  },
  {
      "id": 154,
      "url": "https://twitter.com/361833425/status/1712779798462832668",
      "text": "There are over 100 Israeli hostages in #Gaza, among them 12 children kept in the hands of barbaric terrorists.\n#FreeOurKids \n#freeGazaFromHamas\n#HamasMassacre https://t.co/8Cd4zsUap1"
  },
  {
      "id": 155,
      "url": "https://twitter.com/1612042716732424194/status/1713812562830045213",
      "text": "This picture is of a Palestinian woman named Israa Jaabis, a prisoner in the Zionists occupation prisons.\n\nShe is the mother of a child named Moatasem.\n\nEsraa was lovely happy Plastenien woman she was just moved on a new home with her child and her husband She bough gaz tupe &amp; tv… https://t.co/kDsFwUwyhS"
  },
  {
      "id": 156,
      "url": "https://twitter.com/1202541676096565248/status/1618963335751569414",
      "text": "Yet again, we see Hamas, PIJ, et al. calling for the death of Jews. This war cry is not a call for Jews to pay the “Jizya” tax...Khaybar Khaybar ya Yahud is contextually an antisemitic war cry. #FreeGazaFromHamas https://t.co/K2eghiHTaR"
  },
  {
      "id": 157,
      "url": "https://twitter.com/3274810681/status/1714277029468848315",
      "text": "और ये ऑंखे वो मंजर भी देखेगी जिस दिन \nमस्जिद - ए - अकसा आजाद होगी ....\n\nइंशाअल्लाह 🕌\n\n#FreePalpatine\n#FreeGazaFromHamas \n#GazaCity \n#IStandWithPalestine https://t.co/kmeVvhezct"
  },
  {
      "id": 158,
      "url": "https://twitter.com/220347418/status/1711404357764411696",
      "text": "There is poverty in Gaza - that’s true. But there is also great wealth. #TheGazaYouDontSee #FreeGazaFromHamas #StandWithIsrael"
  },
  {
      "id": 159,
      "url": "https://twitter.com/1598641473687257088/status/1714059432915513681",
      "text": "A soldier from the criminal Israeli occupation army rapes a 15-year-old Palestinian girl (the girl \ncommitted suicide)💔\n\n#zionistterror\n#GazaAttack\n#GazzeUnderAttack\n#غزة_الآن #غزه_تباد \n#طوفان_الأقصى #Isarael #palastine\n#PalestineGenocide\n#GazaCity\n#GazaAttack\n#IsraeliNewNazism https://t.co/CZ3flT9euu"
  },
  {
      "id": 160,
      "url": "https://twitter.com/243785567/status/1714280864027492588",
      "text": "Palestinian searching for his family under the rubble after their home was destroyed by the Israeli occupation's aircraft\n\n#IsraeliNewNazism\n#Gaza_under_attack \n#Israel #غزة_الآن\n#OpenRafahCrossing\n#IsraelPalestineConflict https://t.co/UpC0qI7MmF"
  }
]

export const TrendingPost: Post[] =
[ {
  "id": 1,
  "url": "https://www.instagram.com/p/CyRNEfQM2RQ",
  "text": "May Allah grant Gazans the patience and reward them with the highest places in Janna 🤲🏻💔 \n\n#gazaunderattack #freepalestine #freedom #resistance"
}]

